import React from "react";
import { zAttrLabelMeta } from "src/common/attributes/makeAttrLabel/types/ZAttrLabelMeta";
import { ZAttrLabelTreeData } from "src/common/attributes/makeAttrLabel/types/ZAttrLabelTreeData";
import { findNodeByKey } from "src/common/findNodeByKey";
import { AttrTypeName } from "src/types/AttrType";
import { ZAttribute } from "src/types/ZAttribute";
import { ZUid } from "src/types/zUid";
import { getLeaves } from "../../../utils/getLeaves";

export const getObjectRefAttrLabelsMap = (
  attribute: ZAttribute,
  treeData: ZAttrLabelTreeData[],
  labelAtts: ZUid[],
) => {
  const treeDataIdMap = new Map(treeData?.map((d) => [d.attrId, d]));
  const attrTreeData = treeDataIdMap.get(attribute.id);
  if (!attrTreeData) return {};
  const meta = zAttrLabelMeta.parse(attrTreeData.attrLabelMeta);
  if (meta.type !== AttrTypeName.object) {
    throw Error("system error");
  }
  const labels2: [string, string][] = Object.entries(meta.links).map(
    ([entId, keys]) => {
      const nodes = keys
        .map((k) => findNodeByKey(k, [attrTreeData]))
        .filter(Boolean) as ZAttrLabelTreeData[];
      const sortedLeaves = Object.values(
        nodes
          .map(getLeaves)
          .flat()
          .reduce(
            (acc, curr) => {
              const index = labelAtts.findIndex(
                (v) => v === String(curr.attrId),
              );
              if (index === -1) return acc;
              acc[index] = curr;
              return acc;
            },
            {} as Record<number, ZAttrLabelTreeData>,
          ),
      );

      const leaves = sortedLeaves
        .map((l) => l.labels)
        .flat()
        .filter(Boolean) as string[];
      return [entId, leaves.join(",")];
    },
  );
  return labels2.reduce(
    (acc, curr) => {
      const [eId, labels] = curr;
      acc[String(eId)] = labels || "";
      return acc;
    },
    {} as Record<string, React.ReactNode>,
  );
};
